import { useViewType, ViewType } from '@eika/hooks';
import { isHiddenHomeButtonDomain } from './domain-utils';

const getHostname = () => (typeof window === 'undefined' ? '' : window.location.hostname);

export const useHomeButtonVisibility = () => {
    const viewType = useViewType();
    const isMobile = viewType === ViewType.mobile;
    const isHiddenDomain = isHiddenHomeButtonDomain(getHostname());

    return !(isMobile || isHiddenDomain);
};
